import React, { useContext, useEffect, useState } from "react";
import { api, mediaUrl } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { ContentContext } from "@/pages/Layout";
import PageCover from "@/components/PageCover";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export default function Products() {
  const { t, loc } = useApp();
  const content = useContext(ContentContext);
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("all");
  const [sel, setSel] = useState(null);

  useEffect(() => { api.get("/products").then((r) => setItems(r.data)).catch(() => {}); }, []);

  const cats = ["all", ...Array.from(new Set(items.map((i) => i.category).filter(Boolean)))];
  const shown = cat === "all" ? items : items.filter((i) => i.category === cat);

  return (
    <div data-testid="products-page">
      <PageCover testId="products-cover" image={content?.covers?.products}
        overline="BEDAS Collection" title={t("products")} />
      <div className="px-6 md:px-12 py-16 md:py-24">
      <div className="max-w-[1600px] mx-auto">
        <div className="flex flex-wrap gap-3">
          {cats.map((c) => (
            <button key={c} data-testid={`filter-${c}`} onClick={() => setCat(c)}
              className={`px-5 py-2 text-[0.68rem] uppercase tracking-[0.2em] border transition-colors duration-300 ${
                cat === c ? "border-gold text-gold" : "border-white/10 text-neutral-400 hover:text-white"}`}>
              {c === "all" ? t("allProducts") : c}
            </button>
          ))}
        </div>

        {shown.length === 0 ? (
          <p data-testid="products-empty" className="mt-20 text-sm text-neutral-500">{t("noItems")}</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
            {shown.map((p, i) => (
              <button key={p.id} data-testid={`product-card-${i}`} onClick={() => setSel(p)}
                className="group text-left border border-white/5 bg-[#0c0c0c] hover:border-gold/30 transition-colors duration-300">
                  <div className="aspect-[4/5] overflow-hidden bg-black">
                    {p.images?.[0] && (
                      <img src={mediaUrl(p.images[0])} alt={p.name}
                        className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                    )}
                  </div>
                <div className="p-6">
                  <p className="text-[0.6rem] uppercase tracking-[0.22em] text-gold">{p.category}</p>
                  <h3 className="font-serif text-2xl text-white mt-2">{p.name}</h3>
                  <p className="text-sm text-neutral-500 mt-3 line-clamp-2">{loc(p.description)}</p>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
      </div>

      <Dialog open={!!sel} onOpenChange={() => setSel(null)}>
        <DialogContent data-testid="product-dialog" aria-describedby={undefined} className="bg-[#0a0a0a] border border-white/10 max-w-3xl p-0">
          {sel && (
            <div className="max-h-[85vh] overflow-y-auto scrollbar-thin">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
                {(sel.images || []).map((im, i) => (
                  <img key={i} src={mediaUrl(im)} alt="" className="w-full aspect-square object-cover" />
                ))}
              </div>
              <div className="p-8">
                <p className="overline">{sel.category}</p>
                <DialogTitle className="font-serif text-4xl font-light text-white mt-3">{sel.name}</DialogTitle>
                <p className="text-sm text-neutral-400 mt-6 leading-relaxed whitespace-pre-line">{loc(sel.description)}</p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
